<div class="form-wrapper">
  <div class="header">
    <div class="title">{{ "subscribe_to_updates" | transloco}}</div>

    <button
      *ngIf="showCloseBtn"
      type="button"
      class="btn close"
      aria-label="Close"
      (click)="onClose.emit()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="subtitle">{{ "subscribtion_subtitle" | transloco}}</div>

  <div class="row">
    <div class="col-sm-12 col-md-2 vertical-align">
      <label for="wallet">{{'wallet' | transloco}}</label>
    </div>
    <div class="col-sm-12 col-md-10">
      <div class="form-group">
        <input
          disabled
          type="text"
          id="wallet"
          [value]="wallet"
        >
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-2 vertical-align">
      <label for="email">{{'email' | transloco}}</label>
    </div>
    <div class="col-sm-12 col-md-10">
      <div class="form-group">
        <input
          [(ngModel)]="email"
          type="text"
          id="email"
          [disabled]="emailDisabled"
        >
      </div>
    </div>
  </div>

  <div class="notification_preferences">{{ "notification_preferences" | transloco}}:</div>

  <div class="row auto-width">
    <div>
      <app-switch
        [(ngModel)]="notifyOnUnlock"
        ngDefaultControl
      ></app-switch>
    </div>
    <div>{{"notify_on_unlock" | transloco}}</div>
  </div>
  <div class="row auto-width">
    <div>
      <app-switch
        [(ngModel)]="monthlySummary"
        ngDefaultControl
      ></app-switch>
    </div>
    <div>{{"send_monthly_summary" | transloco}}</div>
  </div>

  <div class="row">
    <div>
      <button
        class="btn plain-button text-truncate"
        style="float: right"
        (click)="save()"
      >
        <div>

          <span
            *ngIf="saving"
            class="spinner-border"
            role="status"
          >
            <span class="sr-only"></span>
          </span>
        </div>

        {{'save' | transloco}}
      </button>
    </div>
  </div>
</div>
